export default __webpack_public_path__ + "static/media/ProductSans-Medium.a98140c9.ttf";